export const handleTrustScoreClick = (trustScoreId, history, status) => {
  const url =
    status === 'draft'
      ? `trust-score/edit/${trustScoreId}/credit-check`
      : `/trust-score/view/${trustScoreId}`
  history.push(url)
}

export const updateCurrentSort = (columnName, currentSort, setCurrentSort) => {
  if (currentSort.direction === 'asc' && currentSort.column === columnName) {
    setCurrentSort({
      column: columnName,
      direction: 'desc'
    })
  } else if (currentSort.direction === 'desc' && currentSort.column === columnName) {
    setCurrentSort({
      column: 'default',
      direction: 'desc'
    })
  } else {
    setCurrentSort({
      column: columnName,
      direction: 'asc'
    })
  }
}
